<script>
import ApiClient from '../utils/ApiClient'
import Vue from 'vue'
import store from '../../store'
import SceneService from '@/components/services/SceneService.vue'

export default {
  data () {
    return {
      users: []
    }
  },
  findCustomerPlayList: function (playlistType, transactionId, callback, errorHandler) {
    let targetPath = 'ajax/playlist_customer.php' + '?transactionid=' + transactionId
    let param = '&playlist_type=' + playlistType
    ApiClient.find(targetPath, param, (response) => {
      let index = 0
      let playlist = []
      for (let value in response.data) {
        if (response.data.hasOwnProperty(value)) {
          playlist[index] = response.data[value]
          playlist[index].rank = index
          if (playlist[index].product_id != null) {
            playlist[index].product_id = Number.parseInt(playlist[index].product_id)
          }
          playlist[index].avatar = SceneService.findIconPathBySceneId(response.data[value].scene_id)
          if (response.data[value].comment === null || response.data[value].comment === 'null') {
            playlist[index].comment = ''
          }
        }
        index++
      }
      if (playlistType === 1) {
        store.commit('updateStatePlayListA', playlist)
      } else if (playlistType === 2) {
        store.commit('updateStatePlayListB', playlist)
      }
      callback(playlist)
    }, (error) => {
      Vue.$log.error('findCustomerPlayList failed')
      Vue.$log.error(error)
      errorHandler(error)
    })
  },
  /**
   * 顧客プレイリストに新しく登録する
   * @param params formData
   * @param playListId Number
   * @param transactionId
   **/
  addPlayList: function (params, playListId, transactionId, callback, errorHandler) {
    let targetPath = 'ajax/playlist_customer_add.php'
    ApiClient.create(targetPath, params, {}, (response) => {
      // データを追加後、プレイリストを再取得しstoreの情報を最新にする
      if (response.status >= 200) {
        this.findCustomerPlayList(playListId, transactionId, (response) => {
          callback(response)
        }, (error) => {
          Vue.$log.error(error)
        })
      }
    }, (error) => {
      Vue.$log.error(error)
      errorHandler(error)
    })
  },
  /**
   * 顧客プレイリストの一曲の情報を更新する
   * @param params formData
   **/
  updatePlayListTune: function (params, callback, errorHandler) {
    var targetPath = 'ajax/playlist_customer_update.php'
    ApiClient.create(targetPath, params, {}, (response) => {
      callback(response.data)
    }, (error) => {
      Vue.$log.error(error)
      errorHandler(error)
    })
  },
  /**
   * 顧客プレイリストの楽曲の順序を更新する
   * @param params formData
   **/
  updatePlayListRank: function (params, callback, errorHandler) {
    var targetPath = 'ajax/playlist_customer_rank.php'
    ApiClient.create(targetPath, params, {}, (response) => {
      callback(response.data)
    }, (error) => {
      console.log('updatePlayListRank failed')
      console.log(error)
      errorHandler(error)
    })
  },

  /**
   * 顧客プレイリストからが曲を削除する
   * @param params formData
   **/
  deleteTuneFromPlayList: function (params, callback, errorHandler) {
    var targetPath = 'ajax/playlist_customer_delete.php'
    ApiClient.create(targetPath, params, {}, (response) => {
      callback(response.data)
    }, (error) => {
      console.log('addPlayList failed')
      console.log(error)
      errorHandler(error)
    })
  },
  completeCustomerPlayList (params, callback, errorHandler) {
    var targetPath = 'ajax/customer_complete.php'
    console.log(targetPath)
    ApiClient.create(targetPath, params, {}, (response) => {
      callback(response.data)
    }, (error) => {
      console.log('completeCustomerPlayList failed')
      console.log(error)
      errorHandler(error)
    })
  },
  /**
   * 指定のプレイリスト内の楽曲の数を確認する。
   * @param playListId
   * @return number resultCount プレイリスト内の楽曲の数
   */
  countPlayListTune (playListId) {
    let resultCount = 0
    let specifyPlayList = []
    if (playListId === 1) {
      specifyPlayList = store.state.playlist_a
    } else if (playListId === 2) {
      specifyPlayList = store.state.playlist_b
    }
    for (let i = 0; i < Object.keys(specifyPlayList).length; i++) {
      if (specifyPlayList[i] !== undefined) {
        if (specifyPlayList[i].product_id != null) {
          resultCount++
        }
      }
    }
    return resultCount
  },
  /**
   * 指定したプレイリスト内の未選択楽曲の枠のIDを取得する
   * @param playListId
   * @return {*}
   */
  getNullPlayListBoxId (playListId) {
    let result = null
    let specifyPlayList = []
    if (playListId === 1) {
      specifyPlayList = store.state.playlist_a
    } else if (playListId === 2) {
      specifyPlayList = store.state.playlist_b
    }
    for (let i = 0; i < Object.keys(specifyPlayList).length; i++) {
      if (specifyPlayList[i] !== undefined) {
        if (specifyPlayList[i].product_id == null) {
          result = specifyPlayList[i].customer_playlist_product_id
          break
        }
      }
    }
    return result
  },
  /**
   * プレイリスト内に楽曲が重複していないことを確認するメソッド
   */
  isNotExistDuplicationTune: function (productId, playListType, playListIndex) {
    let result = true
    playListIndex = parseInt(playListIndex)
    productId = parseInt(productId)
    playListType = parseInt(playListType)
    for (let i = 0; i < Object.keys(store.state.playlist_a).length; i++) {
      if (store.state.playlist_a[i] !== undefined) {
        if (parseInt(store.state.playlist_a[i].product_id) === productId) {
          result = false
          if (i === playListIndex && playListType === 1) {
            // プレイリスト箇所を確認する（プレイリストに二つ以上になってしまわないかを確認）
            result = true
          }
        }
      }
    }
    for (let i = 0; i < Object.keys(store.state.playlist_b).length; i++) {
      if (store.state.playlist_b[i] !== undefined) {
        if (parseInt(store.state.playlist_b[i].product_id) === productId) {
          result = false
          if (parseInt(i) === playListIndex && playListType === 2) {
            // プレイリスト箇所を確認する（プレイリストに二つ以上になってしまわないかを確認）
            result = true
          }
        }
      }
    }
    return result
  }
}
</script>



// WEBPACK FOOTER //
// src/components/services/CustomerPlayListService.vue